import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Subject } from 'rxjs';

import {
  Country,
  CountryDialog,
} from '../../dialogs/country-dialog/country-dialog';
import { AnswerService } from '../../services/answer.service';
import axiosClient from '../../services/axios-client';
import { ButtonService } from '../../services/button.service';
import { CindiQuestionnaireService } from '../../services/cindi-questionnaire.service';
import { LoadingService } from '../../services/loading.service';
import { MessageService } from '../../services/message.service';
import { OptionsService } from '../../services/options.service';
import { LoadingScreenComponent } from '../loading-screen/loading-screen.component';
import { ConfirmInputService } from './../../services/confirm-input.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-chat',
  imports: [MatProgressBarModule, LoadingScreenComponent],
  templateUrl: './chat.html',
  styleUrl: './chat.scss',
  encapsulation: ViewEncapsulation.None,
})
export class Chat implements OnInit {
  @ViewChild('submenu') submenu!: ElementRef<HTMLDivElement>;
  isSubmenuOpen: boolean = false;
  progressBarValue!: number;
  private destroy$ = new Subject<void>();
  nextMessageId!: number;

  constructor(
    public dialog: MatDialog,
    private messageService: MessageService,
    private answerService: AnswerService,
    private loadingService: LoadingService,
    private cindiQuestionnaireService: CindiQuestionnaireService,
    private buttonService: ButtonService,
    private optionsService: OptionsService,
    private confirmInputService: ConfirmInputService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private dom: Document,
  ) {}

  async ngOnInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      this.showLoading();
    }
    this.registerPageAccess().finally(() => {
      setTimeout(() => {
        this.hideLoading();
      }, 100);
    });
    await this.messageService.getAllCindiMessages();

    const idPessoa = this.authService.getUserId();
    await this.cindiQuestionnaireService.initCindiQuestionnaire(idPessoa);
    this.answerService.progressBarCount$.subscribe((value: any) => {
      this.progressBarValue = value;
    });

    this.answerService.previousQuestionId$.subscribe(
      async (questionId: any) => {
        if (questionId) {
          this.nextMessageId = questionId + 1;
        }
      },
    );

    this.answerService.continueQuestionsFlow$.subscribe(async (flow: any) => {
      this.cindiQuestionnaireService.continueQuestionsFlow(this.nextMessageId);
    });

    this.optionsService.openCountryModal$.subscribe(async () => {
      await this.openCountryDialogFromChat();
    });
  }

  showLoading() {
    this.loadingService.show();
  }

  hideLoading() {
    setTimeout(() => {
      this.loadingService.hide();
    }, 500);
  }

  async registerPageAccess() {
    return await axiosClient
      .post('api/cindi/page-access', {})
      .then((res) => {
        return res;
      })
      .catch((err: any) => {
        throw Error(err.response?.data?.message ?? 'Erro ao salvar acesso');
      })
      .finally(() => {});
  }

  async openCountryDialogFromChat() {
    const dialogRef = this.dialog.open(CountryDialog, {
      width: '300px',
      height: '600px',
    });
    const question = await this.messageService.getCindiMessage(9);

    dialogRef.afterClosed().subscribe((country: Country) => {
      if (!country) return;

      const userAnswer = country.name;

      this.messageService.addUserMsgToChat(userAnswer);
      this.answerService.setOpenAnswer(question, userAnswer);

      this.confirmInputService.changeInputStatus(true);

      const btn = document.querySelector('.country-btn') as HTMLButtonElement;
      if (btn) btn.disabled = true;
    });
  }

  openSubmenu() {
    this.isSubmenuOpen = true;
  }
}
